import { IAppMenuItem, IAppRoute } from '../App/Services/RouteService';
import InvestmentSetupView from './Views/InvestmentSetup/InvestmentSetupView';
import CatalogueView from './Views/Catalogue/CatalogueView';
import * as CatalogueRoles from "./Models/Security/CatalogueRoles"
import * as Roles from "./Models/Security/Roles"
import InvestorView from "./Views/Investor/InvestorView";
import IssuerView from "./Views/Issuer/IssuerView";
import IssuerInvestmentView from './Views/IssuerInvestments/IssuerInvestmentView';
import InvestorInvestmentView from './Views/InvestorInvestments/InvestorInvestmentView';
import ConfigView from './Views/Config/ConfigView';
import ContactsView from './Views/Contacts/ContactsView';
import DividendProcessingView from './Views/DividendProcessing/DividendProcessingView';
import LetterAuthorisationView from './Views/LetterAuthorisation/LetterAuthorisationView';
import { IntegrityChecking } from '@singularsystems/neo-react-services';
import PaymentExportView from './Views/PaymentExports/PaymentExportView';
import SystemMaintenanceView from './Views/System/SystemMaintenanceView';
import InternalApproversView from './Views/Approvals/InternalApproversView';
import PortalUsersView from './Views/PortalUsers/PortalUsersView';
import PortalTermsAndConditionsView from "./Views/PortalUsers/PortalTermsAndConditionsView";
import LogsView from "./Views/System/LogsView";

const MainRoutes: IAppMenuItem[] = 
    [
        { name: "Investors", icon: "coins", children: [
            { name: "Investors", path: "/investors", component: InvestorView, role: Roles.Investor.View, icon: "user" },
            { name: "Investor Investments", path: "/investor-investment", component: InvestorInvestmentView, role: Roles.InvestorInvestment.View, icon: "coins" },
        ]},
        { name: "Issuers", icon: "university", children: [
            { name: "Issuers", path: "/issuers", component: IssuerView, role: Roles.Issuer.View, icon: "user-secret" },
            { name: "Issuer Investments", path: "/issuer-investment", component: IssuerInvestmentView, role: Roles.IssuerInvestment.View, icon: "university" },
        ]},
        { name: "Processing", icon: "stamp", children: [
            { name: "Dividend Processing", path: "/dividend-processing", component: DividendProcessingView, role: Roles.DividendProcessing.View, icon: "microchip" },
            { name: "Letter Authorisation", path: "/letter-authorisation", component: LetterAuthorisationView, role: Roles.LetterAuthorisation.View, icon: "stamp" },
            { name: "Payment Export", path: "/payment-export", component: PaymentExportView, role: Roles.PaymentExport.View, icon: "file-export" },
        ]},
    ];

const SetupRoutes: IAppMenuItem[] = 
    [
        { name: "Setup", icon: "cogs", children: [
            { name: "Catalogue",  icon: "database", path: "/catalogue", component: CatalogueView, role: CatalogueRoles.GenericRoles.View, routeChildren: CatalogueView.getRouteChildren()},
            { name: "Contacts", icon: "address-book", path: "/contacts", component: ContactsView, role: Roles.Contact.View },
            { name: "Internal Approvers",  icon: "users", path: "/internal-approvers", component: InternalApproversView, role: Roles.InternalApprover.View },
            { name: "Investment Setup", icon: "percent", path: "/investment-setup", component: InvestmentSetupView, role: CatalogueRoles.InvestmentSetup.View },
            { name: "System Config",  icon: "cogs", path: "/system-config", component: ConfigView, role: Roles.Config.View },
        ]},
        { name: "System", collapseSingle: false, children: [
            { name: "Integrity Checking", path: "/integrity-checking", icon: "bug", component: IntegrityChecking.IntegrityCheckingView, role: Roles.System.IntegrityChecks },
            { name: "System Maintenance", path: "/system-maintenance", icon: "wrench", component: SystemMaintenanceView, role: Roles.System.SystemMaintenance },
            { name: "Logs", path: "/logs", icon: "bars", component: LogsView, role: Roles.System.ViewLogs },
        ]},
    ]

const PureRoutes: IAppRoute[] = [];

const PortalUserManagementRoute: IAppMenuItem =
    { name: "Portal Users", path: '/security/portal-users', component: PortalUsersView, anyRoles: [Roles.PortalUsersAdmin.View, Roles.PortalUsersClient.View] };

const PortalUserTermsAndConditionsRoute: IAppMenuItem = 
    { name: "Portal T+Cs", path: "/security/portal-terms-and-conditions", component: PortalTermsAndConditionsView, role: Roles.ClientPortal.TermsAndConditions };

export { 
    MainRoutes,
    SetupRoutes,
    PureRoutes,
    PortalUserManagementRoute,
    PortalUserTermsAndConditionsRoute
}